import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import Markdown from '../Markdown'
import { bodyText, colours } from '../player/playerStyles'

const CaseStudy = ({ block }) => (
  <Box sx={{ maxWidth: '74ch' }}>
    <Box sx={{ p: { xs: 2, sm: 2.5 }, border: `2px solid ${colours.border}`, borderRadius: 1, bgcolor: '#F8FAFC' }}>
      <Typography sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '1rem', fontWeight: 700, color: colours.accent, mb: 1 }}>
        <AssignmentOutlinedIcon aria-hidden="true" />
        Scenario
      </Typography>
      <Markdown sx={bodyText}>{block.body}</Markdown>
    </Box>
    {block.question && (
      <Box sx={{ mt: 2, display: 'flex', gap: 1.25 }}>
        <HelpOutlineIcon sx={{ color: colours.accent, mt: '2px' }} aria-hidden="true" />
        <Box>
          <Typography component="h3" sx={{ fontSize: '1.0625rem', fontWeight: 700, lineHeight: 1.5 }}>
            Think about
          </Typography>
          <Markdown sx={bodyText}>{block.question}</Markdown>
        </Box>
      </Box>
    )}
  </Box>
)

export default CaseStudy
